import CustomModal from 'components/global/CustomModal'
import React, { useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import DropInHeader from './Content/DropInHeader'
import AttendeesList from './Content/AttendeesList'
import { useParams } from 'react-router-dom'
import { convertToUtc } from 'helper/utility'
import CustomModalFooter from 'components/global/CustomModalFooter'
import AddDropIn from '../AddDropInAttendee/AddDropIn'

const DropInModal = () => {
  const { id }: { id: string } = useParams()
  const {
    dropInModalOpen,
    setDropInModalOpen,
    setCheckInOutModalOpen,
    setAddDropInAttendeeModalOpen,
  } = eventAttendanceStore(store => ({
    dropInModalOpen: store.dropInModalOpen,
    setDropInModalOpen: store.setDropInModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    addDropInAttendeeModalOpen: store.addDropInAttendeeModalOpen,
    setAddDropInAttendeeModalOpen: store.setAddDropInAttendeeModalOpen,
  }))

  const [params, setParams] = useState<any>({
    eventId: id,
    date: convertToUtc(new Date()),
  })

  const closeModal = () => {
    setCheckInOutModalOpen(true)
    setDropInModalOpen(false)
  }

  const handleClickAdd = () => {
    setAddDropInAttendeeModalOpen(true)
    setDropInModalOpen(false)
  }

  return (
    <>
      <CustomModal
        openModal={dropInModalOpen}
        isCloseModalCustom
        closeModal={closeModal}
        title="Drop-in"
        width={1200}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Add drop-in attendee"
            btnType="primary"
            onSubmit={handleClickAdd}
          />
        }
      >
        <DropInHeader params={params} setParams={setParams} />
        <AttendeesList params={params} setParams={setParams} />
      </CustomModal>
    </>
  )
}

export default DropInModal
